// extracted by mini-css-extract-plugin
module.exports = {"animate-height":"BigWins_animate-height__3IjLl","List":"BigWins_List__62na8","Title":"BigWins_Title__2isWe","animateHeight":"BigWins_animateHeight__1wbH8"};